import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const evIChargeSignup: IMcAppType = {
  name: "evIChargeSignup",
  path: "/my/service/ev-icharge/signup",
  description: "Power Up - Signup process",
  navFlow: NavFlow.FOCUS,
  title: "Sign up for Power Up",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "evIChargeSignup",
  },
};

export const evIChargeSignupRedirect: IMcAppType = {
  name: "evIChargeSignupRedirect",
  path: "/my/service/ev-icharge/signup/redirect",
  description: "Power Up - Signup process redirect",
  navFlow: NavFlow.FOCUS,
  title: "EV Power Up",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "evIChargeSignupRedirect",
  },
};
